<template>

<div class="mb-10">
  
  <div v-if="this.image.url" class="relative z-10  cursor-pointer object-cover w-full">
    <a v-bind:href="this.image.url" class="" download>
      <div v-if="this.canDownload" class="absolute -top-2 -right-2 hover:bg-fuchsia-50 rounded-full bg-white leading-none text-fuchsia-500 items-center mt-4 mr-4">
        <svg class="m-1 text-fuchsia-500 stroke-current " xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="bevel"><path d="M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 9l-5 5-5-5M12 12.8V2.5"/></svg>
      </div>
    </a>
    
    <img  v-bind:src="this.image.url" class="cursor-pointer bg-gray-100 object-contain z-10 w-full max-h-96 "  v-on:click="openModal()"/>
    
    <prismic-rich-text class="mx-2 text-sm text-gray-500 my-3 h-22" :field="body"/>
  </div>
  
  
  <div id="image-modal" v-show="modalShow"  class="modal z-20 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    
    <div class="modal-content text-left p-2 z-50">
      <img v-on:click="closeModal()" class="z-50" :src="this.image.url" />
    </div>
    
    <div v-on:click="closeModal()" class="modal-overlay cursor-pointer absolute w-full h-full bg-gray-900 opacity-50 z-30"></div>
    <div class="modal-container bg-white cursor-pointer w-auto shadow-sm">
      <div v-on:click="closeModal()"  class="cursor-pointer modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm">
        <svg class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
        </svg>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'PictureBox',
    components:{
    },
    data() {
        return {
            modalShow: false,
            transcriptVideoId: null,
            transcriptVideoShow: false,
            plainLink: null
        }
    },
    props: {
        title: Array,
        body: Array,
        image: Object,
        quote: Boolean,
        context: String,
        link: Object,
        canDownload:{
            type: Boolean,
            default: true
        }

    },
    methods: {
        closeModal() {
            this.modalShow = false;
        },
        openModal() {
            this.modalShow = true
    },
        extractYoutubeId(p) {
            return this.$youtube.getIdFromUrl(p)
        },
        checkTranscriptVideo(){
            if(this.link){
                var longUrl = this.link.url;
                var shortId = this.extractYoutubeId(longUrl);
                
                if(shortId){
                    // console.log(`MediaTile: Got transcript video id - ${shortId}`)
                    this.transcriptVideoId = shortId;
                    this.transcriptVideoShow = true;
                }else{
                    // console.log(`MediaTile: Got a link, but not youtube, leaving alone`)
                    this.plainLink = longUrl;
                }
            }
        }
    },
    created(){
        this.checkTranscriptVideo();
    }

}
</script>
